module.exports = [{
      plugin: require('../node_modules/.pnpm/gatsby-plugin-page-transitions@1.0.8_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/gatsby-plugin-page-transitions/gatsby-browser.js'),
      options: {"plugins":[],"transitionTime":1000},
    },{
      plugin: require('../gatsby-browser.tsx'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/.pnpm/gatsby@5.14.5_babel-eslint@10.1.0_eslint@7.32.0__esbuild@0.17.19_react-dom@18.3.1_react_881c6a79121b44aa15104016f3487884/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
